import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddCardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_card"}/>
}
